import React from "react";
import { useState } from "react";
import styles from "../../../pages/styles";
import { aboutfox, starsalone } from "../../../assets/images";
import { Plus, Minus } from "lucide-react";

const FAQCard = ({ question, answer }) => {
  const [accordionOpen, setAccordionOpen] = useState(false);

  return (
    <div className="group">
      <button
        onClick={() => setAccordionOpen(!accordionOpen)}
        className="flex gap-3 w-full items-start py-3 hover:bg-white/30 px-3 rounded-lg transition-all"
      >
        <div className={`flex-shrink-0 mt-1 ${accordionOpen ? 'text-orangeprimary' : 'text-pinkprimary'}`}>
        {accordionOpen ? (
            <Minus size={20} className="font-bold" />
        ) : (
            <Plus size={20} className="font-bold" />
          )}
        </div>
        <span className={`${styles.paragraph} text-left font-semibold text-darkprimary group-hover:text-pinkprimary transition-colors`}>
          {question}
          </span>
      </button>
      <div
        className={`grid overflow-hidden transition-all duration-300 ease-in-out ${
      accordionOpen
        ? `grid-rows-[1fr] opacity-100`
        : `grid-rows-[0fr] opacity-0`
    }`}
      >
        <div
          className={`${styles.paragraph} text-gray-600 text-left overflow-hidden pl-11 pr-3 pb-3`}
        >
          {answer}
        </div>
      </div>
    </div>
  );
};

const Accordion = () => {
  return (
    <div className="flex-col justify-center">
      <div className="flex flex-col gap-2 bg-white rounded-2xl px-6 py-6 relative z-20 shadow-lg border border-gray-200">
        <h1 className={`${styles.biggerheadingdark} mb-3 md:mb-4 text-center`}>
          Frequently Asked Questions
        </h1>
        <p className={`${styles.paragraph} text-center text-gray-600 mb-3 md:mb-4`}>
          Everything you need to know about Tech Tails classes
        </p>
        
        <FAQCard
          question="What age groups are your courses suitable for?"
          answer="We offer a range of programs catering to all different age groups and skill levels."
        />
        <div className="border-b border-gray-200" />
        
        <FAQCard
          question="How do you adapt to my child's learning pace?"
          answer="We customize the curriculum to match your child's individual needs and learning pace"
        />
        <div className="border-b border-gray-200" />
        
        <FAQCard
          question="What programs do you offer?"
          answer="At the moment, we offer three programs. Private 1:1, Group, and Navigator. The group classes have 4-5 students. Private Classes follow certain course work while Navigator is flexible and personalized to students ability and needs"
        />
        <div className="border-b border-gray-200" />
        
        <FAQCard
          question="My student doesn't learn well in groups. Do you offer private classes?"
          answer="Absolutely! We understand that every student is unique. We offer one-on-one private virtual classes to cater to individual learning styles"
        />
        <div className="border-b border-gray-200" />
        
        <FAQCard
          question="Do you offer in-person classes?"
          answer="At the moment, all our classes are conducted online, and we do not offer in-person sessions. Our virtual private classes provide a safe and personalized learning experience for your child"
        />
        <div className="border-b border-gray-200" />
        
        <FAQCard
          question="How much do classes cost?"
          answer="Starting at $240/month (annual) or $260/month (month-to-month). We offer different prices depending on how many hours you do and your commitment level. We also have different month-to-month plans that can be cancelled with 30 day notice. Contact us for pricing details tailored to your needs."
        />
      </div>
    </div>
  );
};

export default Accordion;
